import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import getUsageTracker from 'pricing-pages-lib/utils/getUsageTracker';
import { getSuiteProductConfigurations } from 'pricing-pages-lib/utils/productConfigUtils';
import { getIsCoreSeatSku, getProductForSkuId } from 'pricing-pages-lib/utils/productsUtils';
import { useContext } from 'react';
import { useSelector } from 'react-redux';
import { PlanBuilderContext } from '../../../context/PlanBuilderContext';
import { useAppSelector } from '../../../reducers';
import { activeCurrencySelector } from '../../../selectors/CurrencySelectors';
import { crmSuiteProductLevelSelector } from '../../../selectors/ProductsSelectors';
import { gatesSelector, productDataSelector, productInventorySelector } from '../../../selectors/SelectorUtils';
import PlanPickerHeader from '../HubPlanPickerList/PlanPickerHeader';
import SuiteProductLevelPicker from './SuiteProductLevelPicker';
import SuiteQuantityPackPickers from './SuiteQuantityPackPickers';

const SuitePlanPicker = () => {
  const {
    productConfigurations,
    setProductConfigurations,
    trackingSource,
    setSuiteProductLevel,
    screen
  } = useContext(PlanBuilderContext);
  const skuIds = productConfigurations.map(({
    skuId
  }) => skuId);
  const selectedProductLevel = useAppSelector(state => crmSuiteProductLevelSelector(state, {
    skuIds
  }));
  const currencyCode = useSelector(activeCurrencySelector);
  const productData = useSelector(productDataSelector);
  const gates = useSelector(gatesSelector);
  const productInventory = useSelector(productInventorySelector);

  const setProductLevel = newProductLevel => {
    if (newProductLevel !== selectedProductLevel) {
      getUsageTracker().track('planBuilderInteraction', {
        component: 'SuitePlanPicker',
        action: 'clicked product level selection button',
        productName: `suite-${newProductLevel.toLowerCase()}`,
        screen,
        currency: currencyCode,
        trackingSource
      });
      setProductConfigurations(oldProductConfigurations => oldProductConfigurations.filter(({
        skuId
      }) => {
        const {
          productLine,
          productLevel
        } = getProductForSkuId({
          productData
        }, {
          skuId
        });
        const isCoreSeat = getIsCoreSeatSku({
          productData
        }, {
          skuId
        });
        return !isCoreSeat && (!productLine || !productLevel);
      }).concat(getSuiteProductConfigurations({
        productData,
        productInventory,
        gates
      }, {
        productLevel: newProductLevel
      })));
      setSuiteProductLevel(newProductLevel);
    }
  };

  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(PlanPickerHeader, {
      productLine: "crmSuite",
      compact: true,
      trackingSource: trackingSource
    }), /*#__PURE__*/_jsx(SuiteProductLevelPicker, {
      setProductLevel: setProductLevel,
      selectedProductLevel: selectedProductLevel
    }), /*#__PURE__*/_jsx(SuiteQuantityPackPickers, {
      setProductLevel: setProductLevel
    })]
  });
};

export default SuitePlanPicker;